export default "__VITE_ASSET__uNRQqOd3__"